import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { useTheme } from 'styled-components';
import { getColor } from '../../V2/Elements/Icons/helpers';
const Icon = React.forwardRef(function Icon({ size = 24, alt, color, className, onClick }, ref) {
    const theme = useTheme();
    const fillColor = React.useMemo(() => getColor({ color, alt, theme }), [color, alt, theme]);
    return (_jsxs("svg", { ref: ref, onClick: onClick, width: size, height: size, viewBox: '0 0 24 24', className: className, fill: fillColor, children: [_jsx("path", { d: 'M5 11.15a.85.85 0 000 1.7v-1.7zm13.601 1.451a.85.85 0 000-1.202l-5.41-5.41a.85.85 0 00-1.201 1.203L16.798 12l-4.808 4.808a.85.85 0 101.202 1.202l5.409-5.409zM5 12.85h13v-1.7H5v1.7z' }), _jsx("path", { stroke: fillColor, strokeLinecap: 'round', strokeWidth: '1.7', d: 'M19.85 3.85L19.85 20.15' })] }));
});
export default React.memo(Icon);
